export default __webpack_public_path__ + "static/media/sky.02677a6b.webp";